<p-inputSwitch
  [(ngModel)]="checked"
  (onChange)="onSwitchClick($event)"
></p-inputSwitch>
